import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';

import { OddCrystalsMobileDrawer } from './drawers/OddCrystalsMobileDrawer';

import { GAME_MODES } from '../../core/constats';
import { OddCrystalsDesktopDrawer } from './drawers/OddCrystalsDesktopDrawer';

class OddCrystalsDrawer extends BaseParentControlDrawer {
  execute(mode, config = {}) {
    return super.execute(mode, config);
  }
}

export const oddCrystalsDrawer = new OddCrystalsDrawer({
  [GAME_MODES.MOBILE]: new OddCrystalsMobileDrawer(),
  [GAME_MODES.DESKTOP]: new OddCrystalsDesktopDrawer(),
  [GAME_MODES.MOBILE_LANDSCAPE]: null,
});
